import firebase from 'firebase/app'


/**
 * Decline a permission for a user
 * @param {String} userId - The id of the user
 * @returns {Promise}
 */
const delinePermission = async (userId, withReturn) => {
  const db = firebase.firestore()

  const mergePermission = db
    .collection('permissions')
    .doc(userId)
    .set({
      user_id: userId,
      declined_at: Date.now(),
      pending: firebase.firestore.FieldValue.delete(),
      validated_at: firebase.firestore.FieldValue.delete(),
    }, { merge: true })

  const updateUser = db
    .collection('users')
    .doc(userId)
    .update({ validated: false })

  await Promise.all([mergePermission, updateUser])

  if (withReturn) {
    const permission = await db.collection('permissions').doc(userId).get()

    return permission.data()
  }

  return mergePermission
}


export default delinePermission
